import React, { FC } from 'react';
import { Clock, Layers, Brain } from 'lucide-react';

interface ContainerOverlayProps {
    type: 'shreds-list' | 'single-shred';
    children: React.ReactNode;
}

const ContainerOverlay: FC<ContainerOverlayProps> = ({ type, children }) => {
    const isShredsList = type === 'shreds-list';

    return (
        <div className="relative">
            {children}
            <div className="absolute inset-0 bg-white/90 backdrop-blur-sm rounded-2xl flex items-center justify-center z-10">
                <div className="text-center p-8">
                    {/* Animated Icon */}
                    <div className="relative mb-6">
                        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-full animate-pulse"></div>
                        <div className="relative w-16 h-16 mx-auto bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center">
                            {isShredsList ? (
                                <Layers className="w-8 h-8 text-white animate-bounce" />
                            ) : (
                                <Brain className="w-8 h-8 text-white animate-pulse" />
                            )}
                        </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-3">
                        {isShredsList ? 'Generating Shreds List' : 'Generating Shred Specifications'}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-600 mb-6 max-w-sm mx-auto">
                        {isShredsList
                            ? 'AI is analyzing your service requirements...'
                            : 'AI is generating detailed specifications...'
                        }
                    </p>

                    {/* Animated Progress Bar */}
                    <div className="relative w-48 mx-auto">
                        <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-gradient-to-r from-indigo-500 to-purple-600 h-2 rounded-full animate-pulse" style={{ width: '60%' }}></div>
                        </div>
                    </div>

                    {/* Time Estimate */}
                    <div className="mt-4 flex items-center justify-center space-x-2 text-sm text-gray-500">
                        <Clock className="w-4 h-4" />
                        <span>
              {isShredsList ? 'Usually takes 1-2 minutes' : 'Can take up to 4 minutes'}
            </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContainerOverlay;